import apiAxios from '../utils/apiAxios';


export const getUsers = async ({ queryKey }) => {
    const [, params] = queryKey;
    const { start, paginatedSize, firstname, lastname, dni } = params;
    const { data } = await apiAxios.get('user', {
        params: {
            start,
            limit: paginatedSize,
            firstname,
            lastname,
            dni
        }
    });
    return data.data;
}

export const getProfessionals = async ({ queryKey }) => {
    const [, params] = queryKey;
    const { start, paginatedSize, firstname, lastname, dni } = params;
    const { data } = await apiAxios.get('user/professional', {
        params: {
            start,
            limit: paginatedSize,
            firstname,
            lastname,
            dni
        }
    });
    return data.data;
}

export const createUser = (data) => {
    return apiAxios.post(`user`, data);
}

export const updateUser = (public_id, data) => {
    return apiAxios.put(`user/${public_id}`, data);
}

export const updatePasswordUserLogged = (data) => {
    return apiAxios.post(`auth/changePass`, data);
}

export const updatePasswordUser = (public_id,data) => {
    return apiAxios.post(`user/${public_id}/changePass`, data);
}